/**
 *
 * Organizations/Show/OptIns/Form
 *
 */

import React from 'react'
import FloatingLabel from '@joeyparis/react-floating-label-input'
import PropTypes from 'prop-types'
import { useMutation, gql } from '@apollo/client'

// Utils
import { useHandleInputChange } from 'hooks'

const CREATE_OPT_IN = gql`
	mutation createOptIn($organization_id: ID, $name: String!, $text: String!) {
		createOptIn(input: { organization_id: $organization_id, name: $name, text: $text }) {
			opt_in {
				id
				name
				text
			}
		}
	}
`

const UPDATE_OPT_IN = gql`
	mutation updateOptIn($id: ID!, $name: String, $text: String) {
		updateOptIn(input: { id: $id, name: $name, text: $text }) {
			opt_in {
				id
				name
				text
			}
		}
	}
`

function Form({ opt_in, handleClose }) {
	const [state, handleInputChange] = useHandleInputChange(opt_in)

	const [createOptIn] = useMutation(CREATE_OPT_IN, {
		onCompleted: () => {
			handleClose(null)
		},
	})

	const [updateOptIn] = useMutation(UPDATE_OPT_IN, {
		onCompleted: () => {
			handleClose(false)
		},
	})

	const onSubmit = (e) => {
		e.preventDefault()

		if (opt_in.id) {
			updateOptIn({ variables: { ...state } })
		} else {
			createOptIn({ variables: { ...state } })
		}
		return false
	}

	return (
		<div>
			<h3>{opt_in.id ? 'Edit' : 'Create'} Custom Opt-In</h3>

			<form onSubmit={onSubmit} /* style={{marginTop: '-1rem'}} */>
				<FloatingLabel
					label="Opt-in Name (not shown to contacts)"
					name="name"
					value={state.name}
					onChange={handleInputChange}
					required
				/>
				<textarea
					name="text"
					className="form-control mt-3"
					value={state.text}
					onChange={handleInputChange}
					required
					rows="6"
				/>

				<div className="d-flex justify-content-end mt-3">
					<button type="button" onClick={handleClose} className="btn btn-danger">
						Cancel
					</button>
					<button className="btn btn-primary ml-2">Save Opt-In</button>
				</div>
			</form>
		</div>
	)
}

Form.propTypes = {
	opt_in: PropTypes.object,
	handleClose: PropTypes.func,
}

export default Form
